export const self_order_slab_url: string = "self_order_slab";